import React from 'react'

import type { ExtendConfirmInfoProps } from '@/components/purchase/components/shared/purchaseConfirmInfo/view'

import BottomSheet from '@/shared/components/BottomSheet'
import { Caption, Text } from '@/shared/components/typography/index'
import { formatTime } from '@/shared/utils/date'

const ExtendConfirmInfo = ({ isOpen, onClick, onClose, carNumValue, price, usingTime }: ExtendConfirmInfoProps) => {
  const bottomContent = (
    <div className="mb-10 flex w-full flex-col">
      <div className="mt-6 rounded-lg bg-main-010 px-4 py-5">
        <Text level="text1" weight="bold" color="main050" className="mb-4 text-left">
          {carNumValue}
        </Text>
        <div className="flex flex-col gap-2">
          <div className="flex justify-between">
            <Caption level="caption2" color="text070">
              주차시간
            </Caption>
            <Caption level="caption2" color="text090">
              {formatTime(usingTime)}
            </Caption>
          </div>
          <div className="flex justify-between">
            <Caption level="caption2" color="text070">
              상품 가격
            </Caption>
            <Caption level="caption2" color="text090">
              {price.toLocaleString()}원
            </Caption>
          </div>
        </div>
      </div>
    </div>
  )
  return (
    <BottomSheet
      isOpen={isOpen}
      title="결제 전 반드시 확인해 주세요."
      ptValue="pt-8"
      bodyContent={bottomContent}
      btnText="위 내용을 확인했습니다"
      className="body-1 h-[56px]"
      pyValue="py-0"
      onClick={onClick}
      onClose={onClose}
    />
  )
}

export default ExtendConfirmInfo
